class CuriositiesShowcase {
    constructor(module) {
        this.module = module

        this.tabLabelContainer = this.module.querySelector('.js-curiosities-showcase-tab-labels')
        this.tabButtons = this.module.querySelectorAll('.js-curiosities-showcase-tab-label')
        this.tabBlocks = this.module.querySelectorAll(`[data-target-id]`)

        this.videoContainerFilter = this.module.querySelector('.curiosities-showcase-video-element-filter')
        this.videoContainerEspresso = this.module.querySelector('.curiosities-showcase-video-element-espresso')
        this.buttonFilter = this.module.querySelector('.curiosities-showcase-video-button-filter')
        this.buttonEspresso = this.module.querySelector('.curiosities-showcase-video-button-espresso')

        if (this.videoContainerFilter) {
            this.youtubeIdFilter = this.videoContainerFilter.dataset.youtubeId
        }

        if (this.videoContainerEspresso) {
            this.youtubeIdEspresso = this.videoContainerEspresso.dataset.youtubeId
        }

        this.sliderFilter = this.module.querySelector('.section-timeline-filter')
        this.sliderEspresso = this.module.querySelector('.section-timeline-espresso')
        this.sliderButtonsFilter = this.module.querySelectorAll('.curiosities-showcase__timeline-item-button-filter')
        this.sliderButtonsEspresso = this.module.querySelectorAll('.curiosities-showcase__timeline-item-button-espresso')
        
        this.playerFilter = null
        this.playerEspresso = null
        
        this.init()
    }

    init() {
        this.addListeners()
        this.addSwiper()
    }

    addListeners() {
        this.tabButtons.forEach(button => {
            button.addEventListener('click', () => {
                const target = button.getAttribute('data-target')

                this.tabButtons.forEach(btn => btn.classList.remove('is-active'))
                button.classList.add('is-active')

                const targetId = this.tabLabelContainer.getAttribute('data-target')

                this.tabBlocks.forEach(block => {
                    if (block.getAttribute('data-target-id') === target) {
                        block.classList.add('is-active')
                    } else {
                        block.classList.remove('is-active')
                    }
                })

                this.module.classList.remove('is-playing')

                this.playerFilter?.pauseVideo()
                this.playerEspresso?.pauseVideo()

                ScrollTrigger.refresh()
            })
        })

        if (this.buttonFilter) {
            console.log('buttonFilter exists')
            this.buttonFilter.addEventListener('click', () => {
                console.log('here')
                if (!this.playerFilter) {
                    this.loadVideoFilter()
                }

                this.module.classList.add('is-playing')
            })
        }

        if (this.buttonEspresso) {
            this.buttonEspresso.addEventListener('click', () => {
                if (!this.playerEspresso) {
                    this.loadVideoEspresso()
                }

                this.module.classList.add('is-playing')
            })
        }
    }

    loadVideoFilter() {
        // Initialize the YT Player
        if (this.videoContainerFilter) {
            this.playerFilter = new YT.Player(this.videoContainerFilter, {
                height: '360',
                width: '640',
                videoId: this.youtubeIdFilter,
                events: {
                    'onReady': (event) => event.target.playVideo(),
                    'onStateChange': (event) => {
                        if (event.data === YT.PlayerState.PLAYING) {
                            this.startTrackingProgressFilter()
                        } else {
                            this.stopTrackingProgressFilter()
                        }
                    }
                }
            })
        }
    }

    loadVideoEspresso() {
        if (this.videoContainerEspresso) {
            this.playerEspresso = new YT.Player(this.videoContainerEspresso, {
                height: '360',
                width: '640',
                videoId: this.youtubeIdEspresso,
                events: {
                    'onReady': (event) => event.target.playVideo(),
                    'onStateChange': (event) => {
                        if (event.data === YT.PlayerState.PLAYING) {
                            this.startTrackingProgressEspresso()
                        } else {
                            this.stopTrackingProgressEspresso()
                        }
                    }
                }
            })
        }
    }

    startTrackingProgressFilter() {
        this.stopTrackingProgressFilter()
        this.progressIntervalFilter = setInterval(() => {
            if (this.playerFilter && typeof this.playerFilter.getCurrentTime === 'function' && this.swiperFilter) {
                const currentTime = this.playerFilter.getCurrentTime()
                let activeIndex = -1

                this.sliderButtonsFilter.forEach((button, index) => {
                    const time = button.getAttribute('data-time')
                    const seconds = time.split(':').reduce((acc, t) => (60 * acc) + parseInt(t, 10), 0)

                    if (currentTime >= seconds) {
                        activeIndex = index
                    }
                })

                if (activeIndex !== -1 && this.swiperFilter.activeIndex !== activeIndex) {
                    this.swiperFilter.slideTo(activeIndex)
                }
            }
        }, 500)
    }

    stopTrackingProgressFilter() {
        clearInterval(this.progressIntervalFilter)
    }

    startTrackingProgressEspresso() {
        this.stopTrackingProgressEspresso()
        this.progressIntervalEspresso = setInterval(() => {
            if (this.playerEspresso && typeof this.playerEspresso.getCurrentTime === 'function' && this.swiperEspresso) {
                const currentTime = this.playerEspresso.getCurrentTime()
                let activeIndex = -1

                this.sliderButtonsEspresso.forEach((button, index) => {
                    const time = button.getAttribute('data-time')
                    const seconds = time.split(':').reduce((acc, t) => (60 * acc) + parseInt(t, 10), 0)

                    if (currentTime >= seconds) {
                        activeIndex = index
                    }
                })

                if (activeIndex !== -1 && this.swiperEspresso.activeIndex !== activeIndex) {
                    this.swiperEspresso.slideTo(activeIndex)
                }
            }
        }, 500)
    }

    stopTrackingProgressEspresso() {
        clearInterval(this.progressIntervalEspresso)
    }

    addSwiper() {
        const initSwiper = () => {
            console.log(this.module.querySelector('[data-target-id="filter"] .js-swiper-prev'))
            if (typeof Swiper !== 'undefined') {
                if (this.sliderFilter) {
                    this.swiperFilter = new Swiper(this.sliderFilter, {
                        slidesPerView: 1,
                        allowTouchMove: false,
                        slidesOffsetAfter: this.sliderFilter.clientWidth - (this.sliderFilter.querySelector('.swiper-slide')?.offsetWidth || 0),
                        navigation: {
                            prevEl: this.module.querySelector('[data-target-id="filter"] .js-swiper-prev'),
                            nextEl: this.module.querySelector('[data-target-id="filter"] .js-swiper-next'),
                        },
                        breakpoints: {
                            768: {
                                slidesPerView: 'auto',
                            },
                        }
                    })

                    this.sliderButtonsFilter.forEach(button => {
                        button.addEventListener('click', () => {
                            const time = button.getAttribute('data-time')

                            if (!this.playerFilter) {
                                this.loadVideoFilter()
                            }

                            this.module.classList.add('is-playing')

                            const seek = () => {
                                if (this.playerFilter && typeof this.playerFilter.seekTo === 'function') {
                                    const seconds = time.split(':').reduce((acc, t) => (60 * acc) + parseInt(t, 10), 0)

                                    this.playerFilter.seekTo(seconds, true)
                                    this.playerFilter.playVideo()
                                } else {
                                    setTimeout(seek, 100)
                                }
                            }

                            seek()
                        })
                    })

                    const navButtonsFilter = this.module.querySelectorAll('[data-target-id="filter"] .js-swiper-prev, [data-target-id="filter"] .js-swiper-next')
                    navButtonsFilter.forEach(navButton => {
                        navButton.addEventListener('click', () => {
                            setTimeout(() => {
                                const activeButton = this.sliderButtonsFilter[this.swiperFilter.activeIndex]
                                if (activeButton) {
                                    activeButton.click()
                                }
                            }, 100)
                        })
                    })
                }

                if (this.sliderEspresso) {
                    this.swiperEspresso = new Swiper(this.sliderEspresso, {
                        slidesPerView: 1,
                        allowTouchMove: false,
                        slidesOffsetAfter: this.sliderEspresso.clientWidth - (this.sliderEspresso.querySelector('.swiper-slide')?.offsetWidth || 0),
                        navigation: {
                            prevEl: this.module.querySelector('[data-target-id="sspresso"] .js-swiper-prev'),
                            nextEl: this.module.querySelector('[data-target-id="sspresso"] .js-swiper-next'),
                        },
                        breakpoints: {
                            768: {
                                slidesPerView: 'auto',
                            },
                        }
                    })

                    this.sliderButtonsEspresso.forEach(button => {
                        button.addEventListener('click', () => {
                            const time = button.getAttribute('data-time')

                            if (!this.playerEspresso) {
                                this.loadVideoEspresso()
                            }

                            this.module.classList.add('is-playing')

                            const seek = () => {
                                if (this.playerEspresso && typeof this.playerEspresso.seekTo === 'function') {
                                    const seconds = time.split(':').reduce((acc, t) => (60 * acc) + parseInt(t, 10), 0)

                                    this.playerEspresso.seekTo(seconds, true)
                                    this.playerEspresso.playVideo()
                                } else {
                                    setTimeout(seek, 100)
                                }
                            }

                            seek()
                        })
                    })

                    const navButtonsEspresso = this.module.querySelectorAll('[data-target-id="espresso"] .js-swiper-prev, [data-target-id="espresso"] .js-swiper-next')
                    navButtonsEspresso.forEach(navButton => {
                        navButton.addEventListener('click', () => {
                            setTimeout(() => {
                                const activeButton = this.sliderButtonsEspresso[this.swiperEspresso.activeIndex]
                                if (activeButton) {
                                    activeButton.click()
                                }
                            }, 100)
                        })
                    })
                }
            } else {
                setTimeout(initSwiper, 100)
            }
        }

        initSwiper()
    }
}

const curiositiesShowcaseModules = document.querySelectorAll('.curiosities-showcase')
curiositiesShowcaseModules.forEach((section) => {
    new CuriositiesShowcase(section)
})

// Inject YouTube API Script
if (!window.YT && !document.querySelector('script[src="https://www.youtube.com/iframe_api"]')) {
    const tag = document.createElement('script')
    tag.src = "https://www.youtube.com/iframe_api"
    const firstScriptTag = document.getElementsByTagName('script')[0]
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
}
